import React from 'react';
import { Building2 } from 'lucide-react';

interface SiteCountBadgeProps {
  count: number;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'info' | 'warning' | 'success';
  showIcon?: boolean;
  className?: string;
}

const SiteCountBadge: React.FC<SiteCountBadgeProps> = ({
  count,
  size = 'md',
  variant = 'default',
  showIcon = true,
  className = ''
}) => {
  // Tailles du composant
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2'
  };

  // Variantes de couleur
  const variantClasses = {
    default: 'bg-gray-100 text-gray-700 border-gray-200',
    info: 'bg-blue-100 text-blue-700 border-blue-200',
    warning: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    success: 'bg-green-100 text-green-700 border-green-200'
  };

  // Icône selon la taille
  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  // Déterminer la variante automatiquement si non spécifiée
  const autoVariant = variant === 'default' 
    ? (count > 0 ? 'info' : 'default')
    : variant;

  const baseClasses = `
    inline-flex items-center font-medium rounded-md border
    ${sizeClasses[size]}
    ${variantClasses[autoVariant]}
    ${className}
  `;

  return (
    <span className={baseClasses}>
      {showIcon && (
        <Building2 className={`${iconSizes[size]} mr-1.5 flex-shrink-0`} />
      )}
      {count} site{count !== 1 ? 's' : ''}
    </span>
  );
};

export default SiteCountBadge;
